module.exports = __webpack_public_path__ + "static/Basilisk-d89e070e6357f8d7241572c6127c0793.jpg";